import { Box, Container, Grid, Typography, Link, IconButton } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'black',
        color: 'white',
        py: 6,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              BSc in Civil Engineering, Αριστοτέλειο Πανεπιστήμιο Θεσσαλονίκης
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              Γρήγοροι Σύνδεσμοι
            </Typography>
            <Box>
              <Link
                component={RouterLink}
                to="/"
                color="inherit"
                sx={{ display: 'block', mb: 1 }}
              >
                Αρχική
              </Link>
              <Link
                component={RouterLink}
                to="/services"
                color="inherit"
                sx={{ display: 'block', mb: 1 }}
              >
                Υπηρεσίες
              </Link>
              <Link
                component={RouterLink}
                to="/about"
                color="inherit"
                sx={{ display: 'block', mb: 1 }}
              >
                Σχετικά
              </Link>
              <Link
                component={RouterLink}
                to="/contact"
                color="inherit"
                sx={{ display: 'block' }}
              >
                Επικοινωνία
              </Link>
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography variant="h6" gutterBottom>
              Στοιχεία Επικοινωνίας
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
              <LocationOnIcon fontSize="small" sx={{ mr: 1, mt: 0.5 }} />
              <Typography variant="body2">
                Διεύθυνση: Μαυρόλοφος Σερρών
                <br />
                620 42
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <PhoneIcon fontSize="small" sx={{ mr: 1 }} />
              <Typography variant="body2">
                Τηλέφωνο: 2321401839
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
              <EmailIcon fontSize="small" sx={{ mr: 1 }} />
              <Typography variant="body2">
                Email: athankrou@yahoo.gr
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
              <IconButton
                color="inherit"
                aria-label="Facebook"
                component="a"
                href="https://shorturl.at/pGH9p"
                target="_blank"
                rel="noopener noreferrer"
                sx={{ 
                  ml: -1.25, 
                  '&:hover': { 
                    bgcolor: 'rgba(255,255,255,0.1)' 
                  } 
                }}
              >
                <FacebookIcon fontSize="medium" />
              </IconButton>
              <Typography variant="body2" sx={{ ml: 1 }}>
                Ακολουθήστε μας
              </Typography>
            </Box>
          </Grid>
        </Grid>
        <Box sx={{ mt: 4, textAlign: 'center' }}>
          <Typography variant="body2">
            © {new Date().getFullYear()} Portfolio Πολιτικού Μηχανικού. Με επιφύλαξη παντός δικαιώματος.
          </Typography>
          <Typography variant="body2" sx={{ mt: 1, fontSize: '0.8rem', opacity: 0.8 }}>
            Developed by <Link href="https://www.linkedin.com/in/theodosios-tsiangas/" target="_blank" rel="noopener noreferrer" color="inherit" sx={{ textDecoration: 'underline' }}>Sakis Tsiaggas</Link>
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 